import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getResellerMerchantById } from "../../../config/LiveApi";
import Spinner from "../../Spin/Spinner";

const ResellerManagement = () => {
  const token = useSelector((store) => store.userReducer.token);
  const resellerId = useSelector((store) => store.userReducer.userId);

  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (resellerId) {
      fetchMerchants();
    }
  }, [resellerId]);

  const fetchMerchants = async () => {
    try {
      setLoading(true);

      const response = await getResellerMerchantById(resellerId, token);
      // console.log("ddddd",response)

      setMerchants(response.data);
    } catch (error) {
      console.error("Error fetching merchants:", error);
      setMerchants([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageWrapper}>
      <div style={card}>
        <h2 style={heading}>Merchant List</h2>

        {loading ? (
          <div style={messageStyle}>
            <Spinner />
          </div>
        ) : merchants.length === 0 ? (
          <div style={messageStyle}>No merchants found</div>
        ) : (
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Name</th>
                {/* <th style={thStyle}>Merchant ID</th> */}
                <th style={thStyle}>Payin %</th>
                <th style={thStyle}>Payout %</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Created At</th>
              </tr>
            </thead>
            <tbody>
              {merchants.map((item) => (
                <tr key={item.id}>
                  <td style={tdStyle}>{item.name || "-"}</td>
                  {/* <td style={{ ...tdStyle, fontFamily: "monospace" }}>
                    {item.merchantId}
                  </td> */}
                  <td style={tdStyle}>{item.payinCommission}%</td>
                  <td style={tdStyle}>{item.payoutCommission}%</td>
                  <td style={tdStyle}>
                    <span
                      style={item.status === 1 ? badgeActive : badgeInactive}
                    >
                      {item.status === 1 ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    {new Date(item.createdAt).toLocaleString("en-IN", {
                      hour12: false,
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

/* ---------------- Styles ---------------- */

const pageWrapper = {
  padding: "40px",
  backgroundColor: "#f9fafb",
  minHeight: "100vh",
};

const card = {
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "16px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
};

const heading = {
  fontSize: "22px",
  fontWeight: "600",
  marginBottom: "20px",
  color: "#111827",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const thStyle = {
  textAlign: "left",
  padding: "14px",
  // backgroundColor: "#f3f4f6",
  backgroundColor: "#fc8019",
  color: "#fff",
  fontWeight: "600",
  fontSize: "14px",
  // color: "#374151",
  borderBottom: "1px solid #e5e7eb",
};

const tdStyle = {
  padding: "14px",
  fontSize: "14px",
  color: "#4b5563",
  borderBottom: "1px solid #f1f1f1",
};

const badgeActive = {
  padding: "5px 12px",
  borderRadius: "20px",
  fontSize: "12px",
  fontWeight: "600",
  backgroundColor: "#e6f9f0",
  color: "#16a34a",
};

const badgeInactive = {
  padding: "5px 12px",
  borderRadius: "20px",
  fontSize: "12px",
  fontWeight: "600",
  backgroundColor: "#fee2e2",
  color: "#dc2626",
};

const messageStyle = {
  textAlign: "center",
  padding: "30px",
  color: "#6b7280",
};

export default ResellerManagement;
